module.exports = __webpack_public_path__ + "static/media/Museo-300.edc05755.woff2";